import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { logoutClient } from '@/hooks/useClientAuth';
import BrandLogo from './BrandLogo';

type ClientHeaderProps = {
  clientName: string;
  backTo?: string;
  backLabel?: string;
};

export default function ClientHeader({ clientName, backTo, backLabel }: ClientHeaderProps) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleLogout = () => {
    logoutClient();
    navigate('/');
  };

  return (
    <header className="sticky top-0 z-40 w-full border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="mx-auto flex w-full max-w-[1280px] items-center justify-between gap-4 px-4 py-3.5 md:px-6">
        <div className="flex items-center gap-3">
          <a href="/dashboard" className="flex items-center gap-3">
            <BrandLogo className="h-14" />
          </a>
          {backTo && (
            <a
              href={backTo}
              className="hidden cursor-pointer items-center gap-1.5 rounded-md border border-background-300 px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 sm:flex"
            >
              <i className="ri-arrow-left-line"></i>
              {backLabel}
            </a>
          )}
        </div>

        <div className="flex items-center gap-3">
          <div className="hidden items-center gap-3 sm:flex">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-100 font-heading text-sm font-semibold text-primary-800">
              {clientName.charAt(0)}
            </span>
            <span className="text-sm font-semibold text-foreground-800">{clientName}</span>
          </div>
          <button
            type="button"
            onClick={handleLogout}
            className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-3.5 py-2 text-sm font-semibold text-foreground-700 transition-colors hover:bg-background-100"
          >
            <i className="ri-logout-box-r-line"></i>
            <span className="hidden sm:inline">{t('common.logout')}</span>
          </button>
        </div>
      </div>
    </header>
  );
}